export class Goal {
    minute: number;
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/shared/goal.model.ts